import React, {
	ChangeEvent,
	FormEvent,
	ReactElement,
	useEffect,
	useState,
} from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useProjects } from ".";

import { RouteComponentProps } from "react-router";

import { CirclePicker } from "react-color";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Loading } from "../ui";
import { Project, projectColorMap } from "./Project";
import { ProjectService } from "./ProjectService";

interface IParams {
	id?: string;
}

export const CreateProjectPage = (
	props: RouteComponentProps<IParams>,
): ReactElement => {
	const [submitDisabled, setSubmitDisabled] = useState(true);
	const [templates, setTemplates] = useState<Project[]>();

	const projectContext = useProjects();
	const projectService = new ProjectService();

	document.title = "Create a new Project";

	useEffect(() => {
		projectContext.setProject!(new Project());
		projectService.findTemplates().then(temps => {
			setTemplates(temps);
		});
	}, []);

	const project = projectContext.project;
	if (!project || !templates) {
		return <Loading />;
	}

	project.accountId = parseInt(props.match.params.id || "", 10);

	const handleSubmit = (event: FormEvent): void => {
		event.preventDefault();

		projectContext.create!()
			.then(newProj => {
				if (newProj) {
					toast.success(`"${newProj.name}" project created`);
					props.history.push(`/projects/${newProj.id}`);
				}
			})
			.catch(error => {
				toast.error(error.message);
			});
	};

	const colors = Object.keys(projectColorMap).map(key => {
		return key;
	});

	const templateOptions = templates.map(t => {
		return { value: t.id, label: t.name };
	});

	return (
		<div className="container" id="create-project">
			<h1 className="mb-4">Create Project</h1>
			<Form onSubmit={handleSubmit}>
				<Form.Group>
					<Form.Label>Project Name</Form.Label>
					<Form.Control
						type="text"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							project.name = event.target.value;
							if (project.name.length > 1) {
								setSubmitDisabled(false);
							} else {
								setSubmitDisabled(true);
							}
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label> Start Date </Form.Label>
					<DatePicker
						className="form-control"
						selected={project.startDate}
						onChange={(date: Date | null) => {
							projectContext.setProject!((prevState: any) => {
								prevState.startDate = date;
								return { ...prevState };
							});
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label> End Date </Form.Label>
					<DatePicker
						className="form-control"
						selected={project.endDate}
						onChange={(date: Date | null) => {
							projectContext.setProject!((prevState: any) => {
								prevState.endDate = date;
								return { ...prevState };
							});
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Project Group</Form.Label>
					<Form.Control
						type="text"
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							project.group = event.target.value;
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Template</Form.Label>
					<Select
						isClearable
						options={templateOptions}
						onChange={(value: any) => {
							if (!value) {
								project.templateId = 0;
							} else {
								project.templateId = value.value;
							}
						}}
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label>Project Color</Form.Label>
					<CirclePicker
						onChange={color => {
							project.color = projectColorMap[color.hex];
						}}
						colors={colors}
					/>
				</Form.Group>
				<Button
					disabled={submitDisabled}
					variant="primary"
					type="submit"
					className="mt-5"
				>
					Submit
				</Button>
			</Form>
		</div>
	);
};
